import React from 'react';

function FacebookCircle({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="For-development"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="B01---IG-setup-modal---expanded"
          transform="translate(-816.000000, -702.000000)"
          fill="#FFFFFF"
        >
          <g id="modal" transform="translate(384.000000, 147.000000)">
            <g
              id="modal-footer"
              transform="translate(0.000000, 528.000000)"
            >
              <g
                id="button-large"
                transform="translate(420.000000, 15.000000)"
              >
                <g
                  id="icon-/-_color-/-attachment"
                  transform="translate(12.000000, 12.000000)"
                >
                  <path
                    d="M22,12 C22,6.47714844 17.5228516,2 12,2 C6.47714844,2 2,6.47714844 2,12 C2,16.9912109 5.65683594,21.1283203 10.4375,21.8785156 L10.4375,14.890625 L7.8984375,14.890625 L7.8984375,12 L10.4375,12 L10.4375,9.796875 C10.4375,7.290625 11.9304687,5.90625 14.2146484,5.90625 C15.3083984,5.90625 16.453125,6.1015625 16.453125,6.1015625 L16.453125,8.5625 L15.1921875,8.5625 C13.95,8.5625 13.5625,9.33339844 13.5625,10.125 L13.5625,12 L16.3359375,12 L15.8925781,14.890625 L13.5625,14.890625 L13.5625,21.8785156 C18.3431641,21.1283203 22,16.9912109 22,12 Z"
                    id="Path"
                    fill={fill}
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FacebookCircle;
